export const BASE_COLORS = {
  blue: '#0F23DF',
  lightBlue: '#03B4DC',
  teal: '#20B2AA',
  green: '#3bc14a',
  darkGreen: '#2e7d32',
  yellow: '#E8C547',
  orange: '#FF9800',
  amber: '#FFC107',
  red: '#D62839',
  burgundy: '#8B1538',
  pink: '#E91E63',
  purple: '#9C27B0',
  indigo: '#3F51B5',
  brown: '#8D6E63',
  gray: '#6B7280',
  softGray: '#D7D7D7',
  white: '#FFFFFF',
};

export const CHART_COLORS = {
  blue: 'rgba(15, 35, 223, 0.7)',
  lightBlue: 'rgba(3, 180, 220, 0.7)',
  teal: 'rgba(32, 178, 170, 0.7)',
  orange: 'rgba(255, 152, 0, 0.7)',
  red: 'rgba(214, 40, 57, 0.7)',
  gray: 'rgba(107, 114, 128, 0.7)',
  green: 'rgba(59, 193, 74, 0.7)',
  purple: 'rgba(156, 39, 176, 0.7)',
  yellow: 'rgba(232, 197, 71, 0.7)',
  amber: 'rgba(255, 193, 7, 0.7)',
  darkGreen: 'rgba(46, 125, 50, 0.7)',
  burgundy: 'rgba(139, 21, 56, 0.7)',
  pink: 'rgba(233, 30, 99, 0.7)',
  indigo: 'rgba(63, 81, 181, 0.7)',
  brown: 'rgba(141, 110, 99, 0.7)',
  softGray: 'rgba(215, 215, 215, 0.7)',
};
